import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { errors, Log, RidesApi } from "@ryde/shared";

import { useRidesNavigation } from "../../navigation/use-rides-navigation";

export const useRideLink = (rideId: number | undefined) => {
  const [link, setLink] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { getRideEditLinkWithFilters } = useRidesNavigation();

  const getRideLink = useCallback(
    async (id: number): Promise<string | null> => {
      try {
        const ride = await RidesApi.fetchRide(id);

        if (!ride?.id) {
          Log.warn(
            t(errors.ride.rideNotFound),
            "Not found original ride of duplication",
          );
          return null;
        }

        return getRideEditLinkWithFilters({
          rideId: id,
          date1: ride.rideStart || new Date().toISOString(),
          date2: ride.rideEnd || new Date().toISOString(),
        });
      } catch (error) {
        Log.warn(t(errors.ride.rideNotFound), error);
        return null;
      }
    },
    [t, getRideEditLinkWithFilters],
  );

  useEffect(() => {
    if (!rideId) {
      setLink(null);
      return;
    }

    const fetchLink = async () => {
      setLoading(true);
      try {
        const result = await getRideLink(rideId);
        setLink(result);
      } catch (error) {
        Log.warn(`Failed to get ride link to ride ${rideId}:`, error);
        setLink(null);
      } finally {
        setLoading(false);
      }
    };

    fetchLink();
  }, [rideId, getRideLink]);

  return { link, loading };
};
